module.exports = __webpack_public_path__ + "static/media/undraw_winners_ao2o 2.82d9605a.svg";